import getDefaultStructure from './defaultStructure';
const structures  = {
    defaultStructure: getDefaultStructure,
}

export default structures;


